import { SHIPPING_LIST_TYPES } from '@common/Checkout/Checkout/constants';
import { ErrorState } from '@common/Checkout/Checkout/types';
import { ErrorReducer } from '@common/Checkout/Checkout/types/reducers';
import {
    REMOVE_ADDRESS_ERROR,
    REMOVE_ADDRESS_FORM_VALIDATION_ERROR,
    REMOVE_GIFT_CARD_CODE_ERROR,
    REMOVE_PAYMENTS_ERROR,
    REMOVE_ORDER_ERROR,
    REMOVE_SHIPPING_ERROR,
    REMOVE_TRANSACTION_ERROR,
    REMOVE_VOUCHER_CODE_ERROR,
    SET_ADDRESS_ERROR,
    SET_CHECKOUT_ERROR,
    SET_GIFT_CARD_CODE_ERROR,
    SET_PAYMENTS_ERROR,
    SET_ORDER_ERROR,
    SET_SHIPPING_ERROR,
    SET_VOUCHER_CODE_ERROR,
} from '../actions/constants';

const initialState: ErrorState = {
    checkout: null,
    order: null,
    voucher: null,
    giftCard: null,
    shipping: {
        [SHIPPING_LIST_TYPES.regular]: null,
        [SHIPPING_LIST_TYPES.pallet]: null,
        shipping: null,
    },
    payments: null,
    address: null,
    transaction: null,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: ErrorReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case SET_CHECKOUT_ERROR: {
            const { payload } = action;
            return { ...state, checkout: payload };
        }

        case SET_ORDER_ERROR: {
            const { payload } = action;
            return { ...state, order: payload };
        }

        case REMOVE_ORDER_ERROR: {
            return { ...state, order: initialState.order };
        }

        case SET_VOUCHER_CODE_ERROR: {
            const { payload } = action;

            return { ...state, voucher: payload };
        }

        case REMOVE_VOUCHER_CODE_ERROR: {
            return { ...state, voucher: initialState.voucher };
        }

        case SET_GIFT_CARD_CODE_ERROR: {
            const { payload } = action;

            return { ...state, giftCard: payload };
        }

        case REMOVE_GIFT_CARD_CODE_ERROR: {
            return { ...state, giftCard: initialState.giftCard };
        }

        case SET_SHIPPING_ERROR: {
            const { payload } = action;

            const { error, listType } = payload;

            const errorType = listType || 'shipping';

            return {
                ...state,
                shipping: {
                    ...state.shipping,
                    [errorType]: error,
                },
            };
        }

        case REMOVE_SHIPPING_ERROR: {
            return { ...state, shipping: initialState.shipping };
        }

        case SET_PAYMENTS_ERROR: {
            const { payload } = action;

            return { ...state, payments: payload };
        }

        case REMOVE_PAYMENTS_ERROR: {
            return { ...state, payments: initialState.payments };
        }

        case SET_ADDRESS_ERROR: {
            const { payload } = action;

            return { ...state, address: payload };
        }

        case REMOVE_ADDRESS_ERROR: {
            return { ...state, address: initialState.address };
        }

        case REMOVE_ADDRESS_FORM_VALIDATION_ERROR: {
            const { payload } = action;

            const validationErrors = [...state.address?.validationErrors || []];
            validationErrors.splice(payload, 1);

            const address = state.address && validationErrors.length ? {
                ...state.address,
                validationErrors,
            } : null;

            return { ...state, address };
        }

        case REMOVE_TRANSACTION_ERROR: {
            return { ...state, transaction: initialState.transaction };
        }

        default:
            return state;
    }
};

export default reducer;
